/**
 * Modal e impresión de comanda tras enviar a cocina.
 * Con print agent envía texto térmico (igual que el ticket) para evitar HTML roto.
 */

function posknComandaAjaxUrl(win) {
	return (
		win.ajaxurl ||
		(win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.ajaxUrl) ||
		'pos-ajax.php'
	);
}

function posknComandaNonce(win) {
	return win.posNonce || (win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.posNonce) || '';
}

function posknNormalizarAnchoImpresora(raw) {
	let ancho = raw || '80';
	if (ancho === '2') ancho = '58';
	if (ancho === '3') ancho = '80';
	return ancho;
}

/** Evita "LLEV6 - LLEV6" cuando número y nombre son iguales. */
function posknFormatMesaComanda(numero, nombre, prefix) {
	const n = String(numero || '').trim();
	const m = String(nombre || '').trim();
	if (!n && !m) return '';
	const body = m && m !== n ? `${n || m} - ${m}` : n || m;
	return prefix ? `${prefix}${body}` : body;
}

export function attachComandaPrintGlobals(win, $) {
	if (win.ultimoOrderIdEnviado === undefined) {
		win.ultimoOrderIdEnviado = null;
	}

	win.mostrarModalImprimirComanda = function mostrarModalImprimirComanda(orderId, mesa) {
		if (!orderId && orderId !== 0) {
			console.error('❌ Error: orderId inválido en mostrarModalImprimirComanda:', orderId);
			win.mostrarNotificacion('Error: No se pudo obtener el ID del pedido', 'error');
			return;
		}

		$('#comanda-numero').text(`#${orderId}`);
		$('#comanda-fecha').text(new Date().toLocaleString('es-VE'));

		if (mesa && mesa.numero) {
			$('#comanda-mesa').text(posknFormatMesaComanda(mesa.numero, mesa.nombre, ''));
			$('#comanda-mesa-container').show();
		} else {
			$('#comanda-mesa-container').hide();
		}

		const anchoGuardado = posknNormalizarAnchoImpresora(localStorage.getItem('poskn_ancho_impresora'));
		$('#ancho-impresora-comanda').val(anchoGuardado);

		$.ajax({
			url: posknComandaAjaxUrl(win),
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_get_order_receipt',
				nonce: posknComandaNonce(win),
				order_id: parseInt(orderId, 10),
			},
			success(response) {
				if (response && response.success && response.data) {
					const total = response.data.total_numeric || parseFloat(response.data.total || 0);
					$('#comanda-total').text(`$${total.toFixed(2)}`);
				} else {
					console.warn('⚠️ Respuesta inesperada al obtener total:', response);
					$('#comanda-total').text('$0.00');
				}
			},
			error(xhr, status, error) {
				console.error('❌ Error al obtener total del pedido:', error, xhr.responseText);
				$('#comanda-total').text('$0.00');
			},
		});

		$('#modal-imprimir-comanda').css('display', 'flex');
		if (typeof win.posknShouldAutoPrint === 'function' && win.posknShouldAutoPrint('comanda')) {
			win.setTimeout(() => {
				if (typeof win.imprimirComanda === 'function') win.imprimirComanda();
			}, 400);
		}
	};

	win.imprimirComanda = function imprimirComanda() {
		if (!win.ultimoOrderIdEnviado) {
			win.mostrarNotificacion('No hay pedido para imprimir', 'error');
			return;
		}

		const anchoSeleccionado = $('#ancho-impresora-comanda').val() || '80';
		localStorage.setItem('poskn_ancho_impresora', anchoSeleccionado);

		$.ajax({
			url: posknComandaAjaxUrl(win),
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_get_order_receipt',
				nonce: posknComandaNonce(win),
				order_id: parseInt(win.ultimoOrderIdEnviado, 10),
			},
			success(response) {
				if (response && response.success && response.data) {
					win.imprimirComandaHTML(response.data);
				} else {
					console.error('❌ Error en respuesta:', response);
					win.mostrarNotificacion(
						`Error al obtener datos del pedido: ${response.data || 'Respuesta inválida'}`,
						'error',
					);
				}
			},
			error(xhr, status, error) {
				console.error('❌ Error AJAX al imprimir comanda:', error, xhr.responseText);
				let errorMsg = 'Error de conexión al obtener datos del pedido';
				if (xhr.responseText) {
					try {
						const errorResponse = JSON.parse(xhr.responseText);
						errorMsg = errorResponse.data || errorMsg;
					} catch (e) {
						errorMsg = `${errorMsg}: ${xhr.statusText}`;
					}
				}
				win.mostrarNotificacion(errorMsg, 'error');
			},
		});
	};

	win.imprimirComandaHTML = function imprimirComandaHTML(orderData) {
		const anchoImpresora = posknNormalizarAnchoImpresora(localStorage.getItem('poskn_ancho_impresora'));

		const config = {
			58: {
				width: '42mm',
				pageSize: '58mm',
				fontSize: '8px',
				titleSize: '10px',
				headerSize: '9px',
				productSize: '8px',
				detailSize: '7px',
				footerSize: '8px',
				padding: '1px',
				maxChars: 24,
			},
			80: {
				width: '64mm',
				pageSize: '80mm',
				fontSize: '10px',
				titleSize: '12px',
				headerSize: '10px',
				productSize: '10px',
				detailSize: '9px',
				footerSize: '9px',
				padding: '2px',
				maxChars: 38,
			},
		};

		const cfg = config[anchoImpresora] || config[80];
		const empresaNombre = 'SISTEMA POSKN';
		const empresaDoc = win.empresaPOS ? win.empresaPOS.documento : '';
		const empresaDir = win.empresaPOS ? win.empresaPOS.direccion : '';
		const empresaTel = win.empresaPOS ? win.empresaPOS.telefonos : '';

		let mesaInfo = '';
		if (orderData.mesa_numero) {
			const mesaTexto = posknFormatMesaComanda(orderData.mesa_numero, orderData.mesa_nombre, 'MESA: ');
			mesaInfo = `<div style="text-align: center; font-weight: bold; font-size: ${cfg.headerSize}; margin: 1px 0;">${mesaTexto}</div>`;
		}

		let tipoServicioInfo = '';
		if (orderData.tipo_servicio_label) {
			// Sin emoji: el agente ESC/POS convierte 🍽️ en ???
			tipoServicioInfo = `<div style="text-align: center; font-weight: bold; font-size: ${cfg.headerSize}; margin: 1px 0; text-transform: uppercase;">${orderData.tipo_servicio_label}</div>`;
		}

		let deliveryInfo = '';
		if (orderData.delivery_fee && parseFloat(orderData.delivery_fee) > 0) {
			deliveryInfo = `<div style="text-align: center; font-weight: bold; font-size: ${cfg.headerSize}; margin: 1px 0;">DELIVERY: $${parseFloat(orderData.delivery_fee).toFixed(2)}</div>`;
		}

		let productosHTML = '';
		orderData.items.forEach((item) => {
			const esNuevo = item.is_new
				? `<span style="background: #ff6b35; color: white; padding: 1px 4px; border-radius: 2px; font-size: ${Math.max(6, parseInt(cfg.detailSize, 10) - 1)}px; margin-left: 2px; font-weight: bold;">NUEVO</span>`
				: '';

			let nombreProducto = item.name;
			if (nombreProducto.length > cfg.maxChars) {
				nombreProducto = `${nombreProducto.substring(0, cfg.maxChars - 3)}...`;
			}

			let opcionesHTML = '';
			const opcionesComanda = (
				Array.isArray(item.ckn_options) && item.ckn_options.length > 0
					? item.ckn_options
					: Array.isArray(item.cknNames) && item.cknNames.length > 0
						? item.cknNames
						: []
			)
				.map((n) => (typeof n === 'string' || typeof n === 'number' ? String(n) : ''))
				.filter((n) => n && n !== 'Array');
			if (opcionesComanda.length > 0) {
				opcionesHTML = `<div style="font-size: ${cfg.detailSize}; color: #000; font-weight: bold; margin-top: 1px; padding-left: 2px; text-align: center;">${opcionesComanda.map((n) => `- ${n}`).join('<br>')}</div>`;
			}

			let notasHTML = '';
			if (item.note && String(item.note).trim() !== '') {
				notasHTML = `<div style="font-size: ${cfg.detailSize}; color: #000; font-weight: bold; margin-top: 1px; padding-left: 2px; text-align: center;">NOTA: ${item.note}</div>`;
			} else if (item.notes && String(item.notes).trim() !== '') {
				notasHTML = `<div style="font-size: ${cfg.detailSize}; color: #000; font-weight: bold; margin-top: 1px; padding-left: 2px; text-align: center;">NOTA: ${item.notes}</div>`;
			}

			productosHTML += `
				<div style="margin: 1px 0; padding: 1px 0; border-bottom: 1px dotted #000;">
					<div style="font-weight: bold; font-size: ${cfg.productSize}; text-align: center; line-height: 1.1;">
						${nombreProducto} ${esNuevo}
					</div>
					${opcionesHTML}
					${notasHTML}
					<div style="text-align: center; font-size: ${cfg.detailSize}; margin-top: 0; font-weight: bold;">Cant: ${item.qty}</div>
				</div>
			`;
		});

		const ticketHTML = `
			<!DOCTYPE html>
			<html>
			<head>
				<title>Comanda #${orderData.id}</title>
				<meta charset="UTF-8">
				<style>
					@page {
						size: ${cfg.pageSize || cfg.width} auto;
						margin: 0 6mm;
					}
					* { margin: 0; padding: 0; box-sizing: border-box; }
					body {
						font-family: 'Arial Narrow', Arial, sans-serif;
						font-size: ${cfg.fontSize};
						margin: 0;
						padding: ${cfg.padding};
						width: ${cfg.width};
						max-width: ${cfg.width};
						font-weight: bold;
						color: #000;
						background: #fff;
						text-align: center;
						line-height: 1.1;
						letter-spacing: -0.02em;
					}
					.header { text-align: center; margin-bottom: 2px; padding-bottom: 1px; border-bottom: 1px solid #000; }
					.title { font-size: ${cfg.titleSize}; font-weight: bold; margin: 1px 0; text-transform: uppercase; }
					.empresa-info { font-size: ${cfg.detailSize}; margin: 0; font-weight: bold; word-wrap: break-word; }
					.order-info { margin: 2px 0; padding: 1px 0; border-top: 1px solid #000; border-bottom: 1px solid #000; }
					.order-info-row { font-size: ${cfg.headerSize}; margin: 1px 0; font-weight: bold; }
					.products-section { margin: 2px 0; }
					.products-title { font-size: ${cfg.headerSize}; font-weight: bold; text-transform: uppercase; margin: 1px 0; padding: 1px 0; border-bottom: 1px solid #000; }
					.footer { margin-top: 2px; padding-top: 1px; border-top: 1px solid #000; font-size: ${cfg.footerSize}; text-align: center; }
					.total { font-weight: bold; font-size: ${cfg.headerSize}; margin: 1px 0; }
					@media print {
						body {
							margin: 0;
							padding: ${cfg.padding};
							width: ${cfg.width};
							max-width: ${cfg.width};
						}
						.no-print { display: none; }
						@page {
							size: ${cfg.pageSize || cfg.width} auto;
							margin: 0 6mm;
						}
					}
				</style>
			</head>
			<body>
				<div class="header">
					<div class="title">${empresaNombre}</div>
					${empresaDoc ? `<div class="empresa-info">${empresaDoc}</div>` : ''}
					${empresaDir ? `<div class="empresa-info">${empresaDir.substring(0, cfg.maxChars * 2)}</div>` : ''}
					${empresaTel ? `<div class="empresa-info">${empresaTel}</div>` : ''}
				</div>

				<div class="order-info">
					<div class="order-info-row">COMANDA #${orderData.id}</div>
					<div class="order-info-row">Fecha: ${orderData.date}</div>
					${mesaInfo}
					${tipoServicioInfo}
					${deliveryInfo}
					<div class="order-info-row">Cliente: ${orderData.customer || 'Cliente General'}</div>
					${orderData.atendido_por ? `<div class="order-info-row">Atendido por: ${String(orderData.atendido_por).replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>` : ''}
				</div>

				<div class="products-section">
					<div class="products-title">PRODUCTOS</div>
					${productosHTML}
				</div>

				<div class="footer">
					<div class="total">TOTAL: $${(orderData.total_numeric || 0).toFixed(2)}</div>
					<div style="font-size: ${cfg.detailSize}; margin-top: 4px;">${new Date().toLocaleString('es-VE')}</div>
				</div>
			</body>
			</html>
		`;

		if (typeof win.posknPrint === 'function') {
			const paperWidth = posknNormalizarAnchoImpresora(
				localStorage.getItem('poskn_ancho_impresora') || anchoImpresora,
			);
			const rc = win.POSKN_RECEIPT_CONFIG || {};
			const companyName =
				rc.companyName ||
				(win.empresaPOS && (win.empresaPOS.nombre || win.empresaPOS.name)) ||
				'';
			let text = '';
			if (typeof win.posknBuildThermalComandaText === 'function') {
				try {
					text = win.posknBuildThermalComandaText(orderData, {
						paperWidth,
						companyName,
					});
				} catch (e) {
					console.warn('Comanda texto térmico falló, se usa HTML:', e);
					text = '';
				}
			}
			win.posknPrint({
				title: `Comanda #${orderData.id}`,
				html: ticketHTML,
				text,
				paperWidth,
				kind: 'comanda',
			});
			return;
		}

		const printWindow = win.open('', '_blank', 'width=400,height=600');
		printWindow.document.write(ticketHTML);
		printWindow.document.close();

		setTimeout(() => {
			printWindow.print();
		}, 250);
	};
}
